'use client';
/* eslint-disable tailwindcss/no-arbitrary-value */
import { CmsOffer } from '../../../types/cmsProduct';
import { currencyFormat } from '../../../utils/helpers/formatters';
import { currencyFormatterNoDecimal } from '../../../utils/number';
import { StaticText } from '../i18n';

interface ProviderRewardProps {
  offers: CmsOffer[];
  providerName: string;
  siteName: string;
  staticText: StaticText;
  itemNumber: number | null;
  bulletColor: string;
}

export const ProviderReward: React.FC<ProviderRewardProps> = ({
  offers,
  providerName,
  siteName,
  staticText,
  itemNumber,
  bulletColor,
}) => {
  const gifts = offers.flatMap((offer) => offer.list_of_gifts ?? []);

  if (gifts.length === 0) return null;

  const subtitle = staticText.providerRewardSubtitle
    ?.replace('{siteName}', siteName)
    .replace('{providerName}', providerName);

  return (
    <div className="flex flex-col gap-spacing/gap/soft-8px">
      {itemNumber != null && (
        <h3 className="font-font-weight/title-2 text-font-size/title-2 leading-line-height/title-2 text-text/secondary">
          {`${itemNumber}. ${staticText.providerRewardTitle?.replace(/^\d+\.\s*/, '')}`}
        </h3>
      )}
      <p className="font-font-weight/body-2 text-font-size/body-2 leading-line-height/body-2-relaxed text-text/secondary">
        {subtitle}
      </p>
      <div className={`flex flex-col gap-spacing/gap/soft-12px ${bulletColor}`}>
        {gifts.map((gift) => {
          const giftValue = gift.gift?.gift_value;
          const prefix = currencyFormat(giftValue?.prefix ?? '');
          const price = giftValue?.price
            ? `${prefix}${currencyFormatterNoDecimal.format(giftValue.price)}`
            : '';
          const label = gift.gift?.gift_title ?? '';

          return (
            <div
              key={gift.gift?.uid}
              className="flex items-start gap-spacing/gap/soft-6px"
            >
              <span className="w-[18px] shrink-0 text-center font-font-weight/bullet-1 text-font-size/bullet-1 leading-line-height/bullet-1">
                •
              </span>
              <span className="text-font-size/body-2">
                <span className="font-semibold leading-line-height/bullet-2">
                  {price ? `${price} ${label}` : label}
                </span>
              </span>
            </div>
          );
        })}
      </div>
    </div>
  );
};
